/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  get_calendar_event_link_action,
  get_calendar_scheduled_event_lists_timings_action,
  get_google_calendar_event_lists_action,
  get_loggedin_user_meta_data_action,
  schedule_interview_request_action,
  unregistered_user_schedule_interview_request_action,
} from "../../../redux/_actions";
import { convertDate } from "../../../_helpers/dateFormatter";
import { showSuccessMessage } from "../../../_uiComponents/ShowMessageSnack";
import { tIntervalGenerator } from "./constants";

function useScheduleInterview() {
  const [eventDetails, setEventDetails] = useState();
  const [isScheduleEventForm, setIsScheduleEventForm] = useState(false);
  const [confirmTimeIndex, setConfirmTimeIndex] = useState(null);
  const [isTimeIntervalListActive, setIsTimeIntervalListActive] =
    useState(false);
  const [formData, setFormData] = useState({});
  const [userMeta, setUserMeta] = useState({});
  const [timeIntervalList, setTimeIntervalList] = useState([]);
  const [calendarScheduledTimings, setCalendarScheduledTimings] = useState([]);
  const [googleCalendarScheduledTimings, setGoogleCalendarScheduledTimings] =
    useState([]);

  const [isInterviewScheduled, setIsInterviewScheduled] = useState(false);
  const [scheduledEventDetails, setScheduledEventDetails] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { calendarEventLinkData } = useSelector(
    (state) => state.get_calendar_event_link_data_reducer
  );

  const { googleCalendarEventListsData } = useSelector(
    (state) => state.get_google_calendar_event_lists_data_reducer
  );

  const { calendarScheduledEventListsData } = useSelector(
    (state) => state.get_calendar_scheduled_event_lists_timings_data_reducer
  );

  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );

  const { unregisteredUserScheduleInterviewDetailData } = useSelector(
    (state) => state.unregistered_user_schedule_interview_request_detail_reducer
  );
  const { scheduleInterviewDetailData } = useSelector(
    (state) => state.schedule_interview_request_detail_reducer
  );

  useEffect(() => {
    let url = new URL(window.location.href);
    let event_link = url.searchParams.get("event_link");

    if (event_link) {
      callApi(event_link);
    }
  }, []);

  useEffect(() => {
    let url = new URL(window.location.href);
    let applicationId = url.searchParams.get("applicant");
    let data = formData;
    if (applicationId) {
      data["candidate_job_application"] = parseInt(applicationId);
      setFormData(data);
    }
  }, []);

  useEffect(() => {
    if (calendarEventLinkData?.data) {
      setEventDetails(calendarEventLinkData?.data);
    }
  }, [calendarEventLinkData]);

  useEffect(() => {
    if (loggedInMetaData?.data) {
      setUserMeta(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);

  useEffect(() => {
    if (unregisteredUserScheduleInterviewDetailData?.data) {
      setScheduledEventDetails(
        unregisteredUserScheduleInterviewDetailData?.data
      );
    }
  }, [unregisteredUserScheduleInterviewDetailData]);

  useEffect(() => {
    if (scheduleInterviewDetailData?.data) {
      setScheduledEventDetails(scheduleInterviewDetailData?.data);
    }
  }, [scheduleInterviewDetailData]);

  //disabled time intervals
  useEffect(() => {
    if (googleCalendarEventListsData?.data) {
      let resultArr = googleCalendarEventListsData?.data;
      let timeIntervals = [];
      if (resultArr && resultArr.length > 0) {
        for (let i = 0; i < resultArr.length; ++i) {
          let startDateTime =
            resultArr[i]?.start && new Date(resultArr[i].start.dateTime);
          let startTime = startDateTime.toTimeString().split(" ")[0];
          let endDateTime =
            resultArr[i]?.end && new Date(resultArr[i].end.dateTime);
          let endTime = endDateTime.toTimeString().split(" ")[0];
          timeIntervals.push({ end_time: endTime, start_time: startTime });
        }
      }

      setGoogleCalendarScheduledTimings(timeIntervals);
    }
  }, [googleCalendarEventListsData]);
  useEffect(() => {
    if (calendarScheduledEventListsData?.data) {
      let resultArr = calendarScheduledEventListsData?.data;
      let timeIntervals = [];
      if (resultArr && resultArr.length > 0) {
        for (let i = 0; i < resultArr.length; ++i) {
          let startTime = resultArr[i]?.start_time;
          let endTime = resultArr[i]?.end_time;
          timeIntervals.push({ end_time: endTime, start_time: startTime });
        }
      }
      setCalendarScheduledTimings(timeIntervals);
    }
  }, [calendarScheduledEventListsData]);

  const callApi = async (id) => {
    await dispatch(get_calendar_event_link_action(id));

    let stored_user =
      (await localStorage.getItem("jigsawUser")) &&
      JSON.parse(localStorage.getItem("jigsawUser"));

    if (stored_user) await dispatch(get_loggedin_user_meta_data_action());
  };

  const callMentorEventsApi = async (d, mentorId) => {
    await dispatch(
      get_google_calendar_event_lists_action({
        event_creator_user_id: mentorId,
        for_date: d,
      })
    );
    await dispatch(
      get_calendar_scheduled_event_lists_timings_action(mentorId, d)
    );
  };

  const onDateSelect = async (d) => {
    let date = new Date(d);
    let day = new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(
      date
    );

    let formattedDate = convertDate(date);
    //call mentor calendar event details
    callMentorEventsApi(formattedDate, eventDetails.event_details?.created_by);

    let data = formData;
    data["interview_date"] = formattedDate;
    setFormData(data);
    let filtereDayTimeIntervals =
      eventDetails.availability_details?.local_time[day.toLocaleLowerCase()];
    // let filtereDayTimeIntervals =
    //   eventDetails?.availability_details &&
    //   eventDetails.availability_details?.days &&
    //   eventDetails.availability_details.days.filter(
    //     (item) => item.day === day.toLocaleLowerCase()
    //   );
    let availableTimeIntervals = [];
    if (!filtereDayTimeIntervals || filtereDayTimeIntervals.length === 0) {
      setTimeIntervalList([]);
    } else {
      for (let i = 0; i < filtereDayTimeIntervals.length; i++) {
        let arr = tIntervalGenerator(
          filtereDayTimeIntervals[i].start_time,
          filtereDayTimeIntervals[i].end_time,
          eventDetails?.event_details && eventDetails.event_details?.duration
        );
        availableTimeIntervals = availableTimeIntervals.concat(arr);
      }
      setTimeIntervalList(availableTimeIntervals);
    }
    setIsTimeIntervalListActive(true);
  };

  const onTimeClick = (tIndex) => {
    setConfirmTimeIndex(tIndex);
  };

  const onTimeConfirm = (time) => {
    time = time.split("-");
    let data = formData;
    data["start_time"] = time[0];
    data["end_time"] = time[1];
    data["event"] =
      eventDetails?.event_details && eventDetails.event_details?.id;
    data["event_creator"] =
      eventDetails?.event_details && eventDetails.event_details?.created_by;
    // if (loggedInMetaData?.data) {
    //   data["mentor"] =
    //     eventDetails?.event_details && eventDetails.event_details?.created_by;
    // } else {
    //   data["registered_user"] =
    //     eventDetails?.event_details && eventDetails.event_details?.created_by;
    // }
    setFormData(data);
    setIsScheduleEventForm(true);
  };

  const onBackClick = () => {
    setIsScheduleEventForm(false);
    setConfirmTimeIndex(null);
  };

  const onTimeCancel = () => {
    setConfirmTimeIndex(null);
  };

  const onFormInputChange = (e) => {
    let data = formData,
      name = e.target.name,
      value = e.target.value;
    data[name] = value;

    setFormData(data);
  };

  const onScheduleEventConfirmClick = async () => {
    if (formData?.candidate_job_application || userMeta?.id) {
      await dispatch(schedule_interview_request_action(formData));
    } else {
      await dispatch(
        unregistered_user_schedule_interview_request_action(formData)
      );
    }

    setIsInterviewScheduled(true);
    setIsScheduleEventForm(false);
  };

  const validateGoogleCalendarInterval = (interval) => {
    let str = interval.split("-");
    let disabled = { disabled: false };
    let disabledTimings = calendarScheduledTimings.concat(
      googleCalendarScheduledTimings
    );

    disabledTimings.map((item) => {
      if (item.start_time === str[0]) {
        disabled.disabled = true;
      }
      if (item.end_time === str[1]) {
        disabled.disabled = true;
      } else if (str[0] < item.start_time) {
        if (str[1] > item.start_time) {
          disabled.disabled = true;
        }
      } else if (str[0] > item.start_time) {
        if (str[0] < item.end_time) {
          disabled.disabled = true;
        }
      }
    });

    return disabled.disabled;
  };

  const onCalendarBackClick = () => {
    navigate(-1);
  };

  const onJoinEventClick = () => {
    if (scheduledEventDetails?.hms_room_id)
      navigate(
        `/scheduled-interview/join-new-event/${scheduledEventDetails?.id}/${scheduledEventDetails?.hms_room_id}`
      );
  };

  const onEventCopyLinkClick = () => {
    if (scheduledEventDetails?.id) {
      const isDev =
        !process.env.NODE_ENV || process.env.NODE_ENV === "development";
      const url = isDev
        ? `http://localhost:3000/scheduled-interview/join-new-event/${scheduledEventDetails?.id}/${scheduledEventDetails?.hms_room_id}`
        : `${process.env.REACT_APP_DEV_ROOT_URL}/scheduled-interview/join-new-event/${scheduledEventDetails?.id}/${scheduledEventDetails?.hms_room_id}`;
      window.navigator.clipboard.writeText(url);

      showSuccessMessage(`Event Link copied ${url}`);
    }
  };

  return {
    formData,
    confirmTimeIndex,
    isTimeIntervalListActive,
    isScheduleEventForm,
    eventDetails,
    userMeta,
    timeIntervalList,
    isInterviewScheduled,
    scheduledEventDetails,

    onTimeClick,
    onDateSelect,
    onTimeConfirm,
    onTimeCancel,
    onBackClick,
    onFormInputChange,
    onScheduleEventConfirmClick,
    validateGoogleCalendarInterval,
    onCalendarBackClick,
    onJoinEventClick,
    onEventCopyLinkClick,
  };
}

export default useScheduleInterview;
